import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';
import { useAuth } from './AuthContext';
import './Navbar.css';

const AppNavbar = () => {
    const location = useLocation();
    const isActive = (path) => location.pathname === path;
    const { isWolfUser, isPrivateUser } = useAuth();

    return (
        <Navbar bg="dark" variant="dark" expand="lg" fixed="top" className="custom-navbar">
            <div className="container">
                <Navbar.Brand as={Link} to="/">Machina Quanta</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link
                            as={Link}
                            to="/"
                            className={isActive('/') ? 'active' : ''}
                        >
                            Home
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to="/models"
                            className={isActive('/models') ? 'active' : ''}
                        >
                            Models
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to="/momentum"
                            className={isActive('/momentum') ? 'active' : ''}
                        >
                            Momentum
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to="/volatility"
                            className={isActive('/volatility') ? 'active' : ''}
                        >
                            Volatility
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to="/seasonality"
                            className={isActive('/seasonality') ? 'active' : ''}
                        >
                            Seasonality
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to="/sector-research"
                            className={isActive('/sector-research') ? 'active' : ''}
                        >
                            Sector Research
                        </Nav.Link>
                        {isPrivateUser && (
                            <Nav.Link
                                as={Link}
                                to="/signals"
                                className={isActive('/signals') ? 'active' : ''}
                            >
                                Signals
                            </Nav.Link>
                        )}
                        {isPrivateUser && (
                            <Nav.Link
                                as={Link}
                                to="/technicals"
                                className={isActive('/technicals') ? 'active' : ''}
                            >
                                Technicals
                            </Nav.Link>
                        )}
                        <Nav.Link
                            as={Link}
                            to="/education"
                            className={isActive('/education') ? 'active' : ''}
                        >
                            Education
                        </Nav.Link>
                        {isWolfUser && (
                            <Nav.Link
                                as={Link}
                                to="/wolf"
                                className={isActive('/wolf') ? 'active' : ''}
                            >
                                Wolf
                            </Nav.Link>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </div>
        </Navbar>
    );
};

export default AppNavbar;
